import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ConfigService, GtmAnnouncerService, StorageService } from "src/app/main";
import isWebview from 'is-ua-webview';

declare const _etmc: any; 

@Component({
  selector: "body",
  templateUrl: "guanabara-index.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class GuanabaraIndexComponent implements OnInit {
  public message: string = "Estamos carregando";
  public loaderStatus: boolean = false;
  public showWpp: boolean = true;

  public constructor(
    private appStorage: StorageService,
    public configService: ConfigService,
    private gtmAnnouncerService: GtmAnnouncerService,

  ) {
      this.gtmAnnouncerService.announceEvent({cookieAccepted: this.getCookie('cookie_consent') })
      _etmc.push(["setOrgId", "514008681"]);
      let loggedCustomer = this.appStorage.getLoggedCustomer();
    if (loggedCustomer != null) {
      _etmc.push(["setUserInfo", {
          "name": loggedCustomer.name,
          "email": loggedCustomer.email,
          "phone": loggedCustomer.phoneNumber,
          "empresa": "Guanabara"
      }]);
    } 
      _etmc.push(["trackPageView", {
        "empresa": "Guanabara"
      }]);
  }

  getCookie(cname: string) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  ngOnInit() {
    let loaderMessageBox = document.querySelector(
      ".message-loader"
    ) as HTMLDivElement;

    this.showWpp = isWebview(navigator.userAgent) ? false : true;

    if (loaderMessageBox) {
      let counter = 1;
      let repeater = 0;
      loaderMessageBox.innerText = "Estamos carregando";

      let interval = setInterval(() => {
        counter++;

        if (repeater == 5) {
          clearInterval(interval);
          loaderMessageBox.innerText = "Estamos carregando";
        }
        if (counter > 4) {
          loaderMessageBox.innerText = "Por favor aguarde";
        }
        if (counter > 8) {
          loaderMessageBox.innerText = "Falta pouco";
        }
        if (counter > 12) {          
          counter = 1;
          repeater += 1
          loaderMessageBox.innerText = "Estamos carregando";                       
        }

      }, 1000);
    }
  }
}
